'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();
import { Checkbox as UICheckbox } from '@workspace/ui/components/checkbox';
import { cn } from '@workspace/ui/lib';
import { useCallback, useEffect, useRef } from 'react';

interface CheckboxDescriptionProps {
  children: React.ReactNode;
  disabled?: boolean;
  className?: string;
}
export const CheckboxDescription = ({
  children,
  disabled = false,
  className,
}: CheckboxDescriptionProps) => {
  return (
    <p
      className={cn(
        'text-sm',
        disabled ? 'text-grey-400 dark:text-grey-800' : 'text-grey-700 dark:text-grey-300',
        className
      )}
    >
      {children}
    </p>
  );
};
interface CheckboxProps {
  id: string;
  label?: string;
  Icon?: React.ComponentType<{ className?: string }>;
  children?: React.ReactNode;
  className?: string;
  value?: boolean;
  onChange?: (checked: boolean) => void;
  readOnly?: boolean;
  disabled?: boolean;
}
export function Checkbox({
  id,
  label,
  Icon,
  children,
  className,
  readOnly = false,
  value,
  onChange,
  disabled = false,
}: CheckboxProps) {
  // Use refs to store latest values to avoid recreating handleClick on every render
  const onChangeRef = useRef(onChange);
  const valueRef = useRef(value);
  // Update refs when props change
  useEffect(() => {
    onChangeRef.current = onChange;
    valueRef.current = value;
  }, [onChange, value]);
  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      if (!disabled && !readOnly) {
        onChangeRef.current?.(!valueRef.current);
      }
    },
    [disabled, readOnly]
  );
  return (
    <div
      className={cn(
        'group outline-grey-400 dark:outline-grey-200 flex rounded-2xl p-6 outline transition-all duration-200',
        value ? 'bg-pink-0 outline-pink-200 dark:bg-neutral-200 dark:outline-pink-200' : '',
        disabled && 'outline-grey-400 dark:outline-grey-700 cursor-not-allowed',
        !disabled &&
          !readOnly &&
          'dark:hover:bg-grey-900 cursor-pointer hover:bg-pink-50 hover:outline-transparent dark:hover:border-transparent',
        readOnly && 'cursor-default',
        children ? 'flex-col gap-[14px]' : '',
        className
      )}
      onClick={handleClick}
    >
      <div className="flex w-full items-center justify-between">
        <div className="flex items-center gap-2">
          {Icon && (
            <Icon
              className={cn(
                'size-5',
                value ? 'text-pink-400 dark:text-pink-400' : 'text-primary dark:text-neutral-100'
              )}
            />
          )}
          {label && (
            <label
              htmlFor={id}
              className={cn(
                'flex h-9 items-center gap-[16px] align-middle text-base leading-tight font-medium text-neutral-200 dark:text-neutral-100',
                disabled ? 'text-grey-400 dark:text-grey-800 cursor-not-allowed' : 'cursor-pointer',
                className
              )}
              onClick={handleClick}
            >
              {label || 'Label for checkbox'}
            </label>
          )}
        </div>
        <UICheckbox
          id={id}
          checked={value ?? false}
          onCheckedChange={onChange}
          disabled={disabled}
          aria-label={label || 'Label for checkbox'}
          className="h-5 w-5"
        />
      </div>
      <div className={cn(Icon ? 'ml-8' : '')}>{children}</div>
    </div>
  );
}
